module.exports = __webpack_public_path__ + "img/terawulf.a75247c4.png";